import React from 'react';
import PropTypes from 'prop-types';
import RenderPercentageInputField from 'components/form/InputFields/RenderPercentageInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, isInvalid, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';

class AccountYieldsEditForm extends React.Component {
    componentDidMount() {
        const {
            data,
            initialize,
        } = this.props;

        initialize({
            account_id: data.account_id,
            yield: data.yield,
        });
    }

    render() {
        const {
            handleSubmit,
            handleSubmitForm,
            invalid,
            submitting,
            translate,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ AutoCompleteFilter }
                                    label='resources.account_yields.fields.accountId'
                                    name='account_id'
                                    optionValue='id'
                                    reference='accounts'
                                    searchBy='name'
                                    searchParams={ {
                                        size: '12',
                                        sort_by: 'name',
                                        sort_direction: 'asc',
                                    } }
                                    source='account_id'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderPercentageInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.account_yields.fields.yield') }
                                    max='80'
                                    min='-20'
                                    name='yield'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

AccountYieldsEditForm.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm(),
);

export default enhance(AccountYieldsEditForm);



// WEBPACK FOOTER //
// ./src/pages/account-yields/edit/AccountYieldsEditForm.js